import React from 'react';
import AdminLayoutWrapper from '../../components/layout/AdminLayoutWrapper';
import { Box, Typography, Grid, Card, CardContent } from '@mui/material';

export default function AdminDashboard() {
  return (
    <AdminLayoutWrapper>
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ mt: 4 }}>
          Welcome to Admin Dashboard
        </Typography>
        
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <Card>
              <CardContent>
                <Typography variant="h6" component="h2">
                  Total Users
                </Typography>
                <Typography variant="h4" color="primary">
                  1,234
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid item xs={12} md={6} lg={3}>
            <Card>
              <CardContent>
                <Typography variant="h6" component="h2">
                  Active Subscriptions
                </Typography>
                <Typography variant="h4" color="primary">
                  856
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid item xs={12} md={6} lg={3}>
            <Card>
              <CardContent>
                <Typography variant="h6" component="h2">
                  Support Requests
                </Typography>
                <Typography variant="h4" color="primary">
                  23
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid item xs={12} md={6} lg={3}>
            <Card>
              <CardContent>
                <Typography variant="h6" component="h2">
                  Revenue
                </Typography>
                <Typography variant="h4" color="primary">
                  $45,678
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </AdminLayoutWrapper>
  );
}
